import {
  BadgeEuro, Baby, BatteryCharging, Circle, Clock, GlassWater, Languages, Luggage, PlaneLanding, ShieldCheck, Signature, Snowflake, Sparkles, Users, Wifi,
} from "lucide-react";
import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/lib/content";
import { waLink } from "@/lib/site";
import { Reveal, SectionHeading } from "./Primitives";
import { WhatsAppIcon } from "./BrandIcons";

const ICONS = { BadgeEuro, Baby, BatteryCharging, Clock, GlassWater, Languages, Luggage, PlaneLanding, ShieldCheck, Signature, Snowflake, Sparkles, Users, Wifi };

export const Icon = ({ name, className = "h-5 w-5" }) => {
  const C = ICONS[name] || Circle;
  return <C className={className} strokeWidth={1.4} />;
};

export const FAQ = () => (
  <section className="section-y bg-silver/60" data-testid="faq-section">
    <div className="container-x grid gap-12 lg:grid-cols-12">
      <SectionHeading
        className="lg:col-span-4"
        eyebrow="Good to know"
        title="Questions, answered"
        text="Everything you need before you land. Anything else? We are one message away."
      />
      <Reveal className="lg:col-span-8">
        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`f-${i}`} className="border-slate-200">
              <AccordionTrigger className="py-6 text-left font-serif text-xl text-ink hover:no-underline md:text-2xl" data-testid={`faq-trigger-${i}`}>
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-base leading-relaxed text-slate-600">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);

export const CtaBanner = () => (
  <section className="container-x pb-20 md:pb-28" data-testid="cta-banner">
    <Reveal className="media-frame relative overflow-hidden bg-ink px-6 py-16 text-white sm:px-12 md:py-24">
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full border border-gold/30" />
      <div className="pointer-events-none absolute -right-10 -top-10 h-72 w-72 rounded-full border border-gold/15" />
      <span className="eyebrow">Your driver is waiting</span>
      <h2 className="heading-lg mt-5 max-w-2xl text-white">Land, relax, and let us take it from here.</h2>
      <p className="mt-5 max-w-xl text-white/65">Book in under two minutes. Fixed price, flight tracking included, 24/7.</p>
      <div className="mt-10 flex flex-wrap gap-3">
        <Link to="/booking" className="btn btn-gold" data-testid="cta-book-now-button">Book Now</Link>
        <a href={waLink()} target="_blank" rel="noreferrer" className="btn btn-ghost-light" data-testid="cta-whatsapp-button">
          <WhatsAppIcon className="h-4 w-4" /> WhatsApp us
        </a>
      </div>
    </Reveal>
  </section>
);

export const TrustStrip = ({ dark = false }) => (
  <div className={`flex flex-wrap gap-x-8 gap-y-3 text-xs uppercase tracking-[0.2em] ${dark ? "text-white/75" : "text-slate-500"}`} data-testid="trust-strip">
    {[
      ["PlaneLanding", "Flight tracking included"],
      ["BadgeEuro", "Fixed prices, no hidden fees"],
      ["Clock", "24/7 service"],
    ].map(([icon, label]) => (
      <span key={label} className="flex items-center gap-2">
        <Icon name={icon} className="h-4 w-4 text-gold" /> {label}
      </span>
    ))}
  </div>
);
